<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4" id="H_DEM" >
        <div class="p-formgrid p-grid p-col p-lg-12">
          <div class="p-field p-col-12 p-lg-4">
            <label for="event_name">{{ $t("event_name") }}</label>
            <InputText id="event_name" type="text" v-model="event_name" />
          </div>
          <div class="p-field p-col-12 p-lg-4">
            <label for="startDate">{{ $t("startDate") }}</label>
            <Calendar
              dateFormat="dd/mm/yy"
              :showButtonBar="true"
              :monthNavigator="true"
              :yearNavigator="true"
              yearRange="2000:2050"  
              :locale="th"
              id="disaster_startDate"
              v-model="startDate"
            ></Calendar>
          </div>
          <div class="p-field p-col-12 p-lg-4">
            <label for="toDate">{{ $t("toDate") }}</label>
            <Calendar
              dateFormat="dd/mm/yy"
              :showButtonBar="true"
              :monthNavigator="true"
              :yearNavigator="true"
              yearRange="2000:2050"  
              :locale="th"
              id="disaster_toDate"
              v-model="toDate"
            ></Calendar>
          </div>
        </div>

        <div class="p-formgrid p-grid p-col">
          <div class="p-field p-col-12 p-lg-4">
            <label for="disasterType">{{ $t("disaster_type") }}</label>
            <Dropdown
              v-model="disasterTypeSelect"
              :options="disasterTypeOptions"
              optionLabel="system_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="disasterTypeOptions">
                <div v-if="disasterTypeOptions.value">
                  <div>{{ disasterTypeOptions.value.system_name }}</div>
                </div>
                <span v-else>
                  {{ disasterTypeOptions.placeholder }}
                </span>
              </template>
              <template #option="disasterTypeOptions">
                <div class="EV_disasterOptions">{{ disasterTypeOptions.option.system_name }}</div>
              </template>
            </Dropdown>
          </div>
          <div class="p-field p-col-12 p-lg-4">
            <label for="disasterDetailOptions">{{
              $t("disaster_detail")
            }}</label>
            <Dropdown
              v-model="disasterDetailSelect"
              :options="disasterDetailOptions"
              optionLabel="system_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="disasterDetailOptions">
                <div v-if="disasterDetailOptions.value">
                  <div>{{ disasterDetailOptions.value.system_name }}</div>
                </div>
                <span v-else>
                  {{ disasterDetailOptions.placeholder }}
                </span>
              </template>
              <template #option="disasterDetailOptions">
                <div>{{ disasterDetailOptions.option.system_name }}</div>
              </template>
            </Dropdown>
          </div>
          <div class="p-field p-col-12 p-lg-4">
            <label for="disasterStatusOptions">{{
              $t("disaster_status")
            }}</label>
            <Dropdown
              v-model="disasterStatusSelect"
              :options="disasterStatusOptions"
              optionLabel="name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="disasterStatusOptions">
                <div v-if="disasterStatusOptions.value">
                  <div>{{ disasterStatusOptions.value.name }}</div>
                </div>
                <span v-else>
                  {{ disasterStatusOptions.placeholder }}
                </span>
              </template>
              <template #option="disasterStatusOptions">
                <div>{{ disasterStatusOptions.option.name }}</div>
              </template>
            </Dropdown>
          </div>
        </div>

        <div class="p-formgrid p-grid p-col">
          <div class="p-field p-col-12 p-lg-4">
            <label for="provinceOptions">{{ $t("province") }}</label>
            <Dropdown
              v-model="selectedProvince"
              :options="provinceOptions"
              optionLabel="province_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="provinceOptions">
                <div v-if="provinceOptions.value">
                  <div>{{ provinceOptions.value.province_name }}</div>
                </div>
              </template>
              <template #option="provinceOptions">
                <div>{{ provinceOptions.option.province_name }}</div>
              </template>
            </Dropdown>
          </div>
          <div class="p-field p-col-12 p-lg-4">
            <label for="amphurOptions">{{ $t("amphur") }}</label>
            <Dropdown
              :disabled="isDisabledAmphur == 1"
              v-model="selectedAmphur"
              :options="amphurOptions"
              optionLabel="amphur_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="amphurOptions">
                <div v-if="amphurOptions.value">
                  <div>{{ amphurOptions.value.amphur_name }}</div>
                </div>
              </template>
              <template #option="amphurOptions">
                <div>{{ amphurOptions.option.amphur_name }}</div>
              </template>
            </Dropdown>
          </div>
          <div class="p-field p-col-12 p-lg-4">
            <label for="tambonOptions">{{ $t("tambon") }}</label>
            <Dropdown
              :disabled="isDisabledTambon == 1"
              v-model="selectedTambon"
              :options="tambonOptions"
              optionLabel="tambon_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="tambonOptions">
                <div v-if="tambonOptions.value">
                  <div>{{ tambonOptions.value.tambon_name }}</div>
                </div>
              </template>
              <template #option="tambonOptions">
                <div>{{ tambonOptions.option.tambon_name }}</div>
              </template>
            </Dropdown>
          </div>
        </div>

        <div class="p-formgrid p-grid p-col">
          <div class="p-field p-col-12 p-lg-4">
            <label for="disaster_location">{{ $t("disaster_location") }}</label>
            <InputText
              id="disaster_location"
              type="text"
              v-model="disaster_location"
            />
          </div>
          <div class="p-field p-col-12 p-lg-6">
            <label for="organizeOptions">{{ $t("organize_name") }}</label>
            <Dropdown
              v-model="selectedOrganize"
              :options="organizeOptions"
              optionLabel="organize_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
            >
              <template #value="organizeOptions">
                <div v-if="organizeOptions.value">
                  <div>{{ organizeOptions.value.organize_name }}</div>
                </div>
              </template>
              <template #option="organizeOptions">
                <div class="EV_disasterOptions">{{ organizeOptions.option.organize_name }}</div>
              </template>
            </Dropdown>
          </div>

          <div class="p-col-12 p-lg-2">
            <div class="p-formgrid p-grid p-jc-start" id="DisEM">
              <div class="p-col-6 p-lg-5" style="width: 6rem;">
                <Button
                  @click="searchDisasterInfo()"
                  :label="$t('searchBtn')"
                  class="p-button-info p-mb-2 p-mt-5"
                />
              </div>
              <div class="p-col-6 p-lg-5" style="width: 6rem;">
                <Button
                  @click="selectItem()"
                  :label="$t('selectBtn')"
                  class="p-button-success p-mb-2 p-mt-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fieldset>

    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="disasterInfo_table"
        :scrollable="true"
                  scrollHeight="500px"
        :paginator="true"
        :rows="10"
        ref="dt"
        :selection.sync="selectDisasterEvent"
        :loading="loading"
        dataKey="hazard_id"
        :rowHover="true"
        :filters="filters"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
        <Column field="event_name" :header="$t('event_name')" :sortable="true"  headerStyle="width: 15rem">
          <template #body="dataTable">
            <div hidden>{{ dataTable.data.hazard_id }}</div>
            {{ dataTable.data.event_name }}
          </template>
        </Column>
        <Column
          field="event_date_alias"
          :header="$t('disaster_callDatetime')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
            {{ formatTimeTH(dataTable.data.event_date_alias) }}
          </template>
        </Column>
        <Column
          field="disaster_name"
          :header="$t('disaster_type')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
            {{ dataTable.data.disaster_name }}
          </template>
        </Column>
        <Column
          field="detail_name"
          :header="$t('disaster_detail')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
            {{ dataTable.data.detail_name }}
          </template>
        </Column>
        <Column
          field="event_level"
          :header="$t('disaster_level')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
            {{ dataTable.data.event_level }}
          </template>
        </Column>
        <Column
          field="event_status"
          :header="$t('disaster_status')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.event_status == 'onworking'">
              {{ $t("onworking") }}
            </div>
            <div v-else>{{ $t("finish") }}</div>
          </template>
        </Column>
        <Column
          field="location"
          :header="$t('disaster_location')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.location != ''">
              {{ $t("ib_building_location_no") }} {{ dataTable.data.location }}
            </div>
            {{ dataTable.data.tambon_name }} {{ dataTable.data.amphur_name }}
            {{ dataTable.data.province_name }}
          </template>
        </Column>
        <Column
          field="event_operator_table"
          :header="$t('main_organize')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.event_operator_table == '[]'">-</div>
            <div v-else>
              <div
                v-for="operator in JSON.parse(
                  dataTable.data.event_operator_table
                )"
                :key="operator.operating_id"
              >
                <div v-if="operator.organize[0] == '1'">
                  {{ operator.operating_name }}
                </div>
                <div v-else>-</div>
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
export default {
  name: "disaster-event-multi-select",
  props: ["parentmessage"],
  data() {
    return {
      event_name: "",
      dateYear:"",
      startDate: "",
      toDate: "",
      disasterTypeOptions: [],
      disasterTypeSelect: null,
      disasterDetailOptions: [],
      disasterDetailSelect: null,
      disasterStatusOptions: [
        { id: "getall", name: this.$i18n.t("selectAll") },
        { id: "onworking", name: this.$i18n.t("onworking") },
        { id: "finish", name: this.$i18n.t("finish") },
      ],
      disasterStatusSelect: null,
      provinceOptions: [],
      selectedProvince: null,
      amphurOptions: [],
      selectedAmphur: null,
      isDisabledAmphur: 1,
      tambonOptions: [],
      selectedTambon: null,
      isDisabledTambon: 1,
      disaster_location: "",
      showOrganize: false,
      selectedOrganize: null,
      disasterInfo_table: [],
      filters: {},
      organizeOptions: [],

      selectDisasterEvent: null,
      loading: false,
    };
  },

  mounted() {
    this.selectDisasterEvent = this.parentmessage;
  },

  watch: {
    disasterInfo_table(val) {
      if (val.length > 0) {
        this.loading = false;
      } else {
        this.loading = false;
      }
    },

    async selectedProvince(val) {
      this.selectedAmphur = null;
      if (val != null) {
        this.isDisabledAmphur = 0;
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: { topic: "get-amphur", province_id: val.province_id },
          })
          .then((response) => {
            (this.amphurOptions = response.data.data),
              this.amphurOptions.splice(0, 0, {
                amphur_id: "getall",
                amphur_name: this.$i18n.t("selectAll"),
              });
          });
      } else {
        this.isDisabledAmphur = 1;
        this.selectedAmphur = null;
      }
    },

    async selectedAmphur(val) {
      this.selectedTambon = null;
      if (val != null) {
        this.isDisabledTambon = 0;
        await this.axios
          .post(`${this.$url_service}/general/country`, {
            body: { topic: "get-tambon", amphur_id: val.amphur_id },
          })
          .then((response) => {
            (this.tambonOptions = response.data.data),
              this.tambonOptions.splice(0, 0, {
                tambon_id: "getall",
                tambon_name: this.$i18n.t("selectAll"),
              });
          });
      } else {
        this.isDisabledTambon = 1;
        this.selectedTambon = null;
      }
    },

    async disasterTypeSelect(val) {
      if (val != null) {
        this.disasterDetailSelect = null;
        await this.axios
          .post(`${this.$url_service}/get/datagroup`, {
            body: { topic: "get-detail-disaster", id: val.system_id },
          })
          .then((response) => {
            (this.disasterDetailOptions = response.data.data),
              this.disasterDetailOptions.splice(0, 0, {
                system_id: "getall",
                system_name: this.$i18n.t("selectAll"),
              });
          });
      } else {
        this.disasterDetailOptions = [];
        this.disasterDetailSelect = null;
      }
    },
    // startDate(val){
    //   const data_check = val instanceof Date && !isNaN(val.valueOf())
    //   if (val) {
    //     if (data_check) {
    //       if (val.getFullYear() < (this.dateYear-493)) {
    //         if (val.getFullYear()+543 < (this.dateYear-50)+543) {
    //           val = new Date(val.getFullYear()+543,val.getMonth(),val.getDate())
    //           this.startDate = val
    //         }
    //       }
    //     }
    //   }
      
    // },
    // toDate(val){
    //   const data_check = val instanceof Date && !isNaN(val.valueOf())
    //   if (val) {
    //     if (data_check) {
    //       if (val.getFullYear() < (this.dateYear-493)) {
    //         if (val.getFullYear()+543 < (this.dateYear-50)+543) {
    //           val = new Date(val.getFullYear()+543,val.getMonth(),val.getDate())
    //           this.toDate = val
    //         }
    //       }
    //     }
    //   }
    // },

  },
  async created() {
    // const yy = new Date(); 
    // const yyyy = parseInt( yy.getFullYear()+543 );
    // this.dateYear = yyyy

    // this.startDate= new Date(yyyy,0,1);
    // this.toDate = new Date(yyyy,yy.getMonth(),yy.getDate());
    await this.axios
          .post(`${this.$url_service}/initial/option`, {
            body: { group: "dg-02" },
          })
          .then((response) => {
            this.disasterTypeOptions= response.data.data,
            this.disasterTypeOptions.splice(0, 0, {
                    system_id: "getall",
                    system_name: this.$i18n.t("selectAll"),
                })
          });
    await this.axios
          .post(`${this.$url_service}/initial/option`, {
            body: { group: "dg-15" },
          })
          .then((response) => {
            this.dailyGroup1Options = response.data.data;
          });
    await this.axios
      .post(`${this.$url_service}/general/country`, {
        body: { topic: "get-province" },
      })
      .then((response) => {
        (this.provinceOptions = response.data.data),
          this.provinceOptions.splice(0, 0, {
            province_id: "getall",
            province_name: this.$i18n.t("selectAll"),
          });
      });
    await this.axios
      .post(`${this.$url_service}/initial/organize`, {
        body: { topic: "get-option" },
      })
      .then(
        (response) => (this.organizeOptions = response.data.data),
        this.organizeOptions.splice(0, 0, {
          organize_id: "getall",
          organize_name: this.$i18n.t("selectAll"),
        })
      );
  },

  methods: {
    async searchDisasterInfo() {
      var start_date, to_date;
      this.loading = true;
      if (this.startDate != "") {
        const start = new Date(this.startDate);
        const ye_s = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          start
        );
        const mo_s = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          start
        );
        const da_s = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          start
        );
        start_date = `${ye_s}-${mo_s}-${da_s}`;
      } else {
        start_date = "";
      }

      if (this.toDate != "") {
        const to = new Date(this.toDate);
        const ye_t = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          to
        );
        const mo_t = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          to
        );
        const da_t = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          to
        );
        to_date = `${ye_t}-${mo_t}-${da_t}`;
      } else {
        to_date = "";
      }
      // console.log(this.selectedOrganize);
      var organize;
      if (this.selectedOrganize == null) {
        organize = {};
      } else {
        organize = { id: this.selectedOrganize.organize_id };
      }
      await this.axios
        .post(`${this.$url_service}/disaster`, {
          body: {
            topic: "search-table",
            name: this.event_name,
            startdate: start_date,
            todate: to_date,
            disaster: this.disasterTypeSelect,
            detail: this.disasterDetailSelect,
            status: this.disasterStatusSelect,
            province: this.selectedProvince,
            amphur: this.selectedAmphur,
            tambon: this.selectedTambon,
            location: this.disaster_location,
            organize: organize,
          },
        })
        .then((response) => (this.disasterInfo_table = response.data.data));
      this.loading = false;
    },

    selectItem() {
      this.$emit("selectEvent", this.selectDisasterEvent);
    },
  },
};
</script>

<style >

@media screen and (max-width: 430px) {
  #H_DEM{
    margin: 0 !important;
  }
  #DGM{
    margin-left: 0 !important;
  }
  #DGM_M{
    margin: 14px 0 0 0 !important;
  }
  #DGM_M_S{
    padding: 7px 0;
  }
  #DisEM{
    justify-content: center;
  }
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
  .multiselect-custom {
    width: 13rem !important; 
  }
}

</style>